var exports = {
  "kL": "x52a3aa3b--4023b7--container",
  "wx": "x52a3aa3b--4023b7--header",
  "yJ": "x52a3aa3b--4023b7--links",
};

module.exports = exports;
